import { StaffActivitiesByDescription } from "../../types";

export const staffActivities: StaffActivitiesByDescription = {
  "New Mexico Cover Letter": {
    parameters: {
      linkUrls: [
        "https://docs.google.com/document/d/11gV88BoNY5HVTtMXPaDofT3i1fzeh4z3/edit?usp=drive_link&ouid=107289238362177691220&rtpof=true&sd=true",
      ],
      staffInputs: {
        fees: true,
        documentTypes: {
          coverLetter: true,
        },
      },
    },
    jurisdictionType: "State",
    consolidated: "Once Per Organization",
    state: "NM",
  },
};
